import React from 'react';
import { motion } from 'framer-motion';

export default function TermsScreen(): React.JSX.Element {
  return (
    <div className="min-h-screen bg-white">
      <section className="pt-32 pb-16 px-4 bg-slate-50">
        <div className="max-w-3xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider bg-amber-50 text-amber-500 mb-6">
              Legal
            </span>
            <h1 className="text-4xl font-extrabold text-slate-900 mb-4">Terms & Conditions</h1>
            <p className="text-slate-500">Last updated: May 2026</p>
          </motion.div>
        </div>
      </section>

      <section className="py-12 px-4 bg-white">
        <div className="max-w-3xl mx-auto prose prose-slate max-w-none">
          {[
            {
              title: '1. Acceptance of Terms',
              content: 'By accessing or using the EcoleMinds platform, you agree to be bound by these Terms and Conditions. If you do not agree to all the terms and conditions, you may not access the platform.'
            },
            {
              title: '2. Course Enrollment',
              content: 'Enrollment in any course is subject to payment confirmation. Upon successful payment, you will receive access to the course materials for the duration specified. All course fees are non-refundable after 7 days from the cohort start date unless otherwise stated.'
            },
            {
              title: '3. User Accounts',
              content: 'You are responsible for maintaining the confidentiality of your account credentials. You agree to notify us immediately of any unauthorized use of your account. We reserve the right to terminate accounts that violate these terms.'
            },
            {
              title: '4. Intellectual Property',
              content: 'All course content, materials, and resources provided on this platform are the intellectual property of EcoleMinds. You may not reproduce, distribute, or create derivative works without explicit written permission.'
            },
            {
              title: '5. Payment & Refunds',
              content: 'Payments are processed securely through Razorpay. Full refunds are available within 7 days of cohort start, no questions asked. After Week 2, prorated refunds may be granted for unforeseen circumstances at our discretion.'
            },
            {
              title: '6. Code of Conduct',
              content: 'Users must maintain professional behavior in all interactions. Harassment, discrimination, or disruptive behavior will result in immediate termination of access without refund.'
            },
            {
              title: '7. Limitation of Liability',
              content: 'EcoleMinds shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the platform.'
            },
            {
              title: '8. Modifications',
              content: 'We reserve the right to modify these terms at any time. Continued use of the platform after changes constitutes acceptance of the modified terms.'
            },
            {
              title: '9. Governing Law',
              content: 'These terms shall be governed by and construed in accordance with the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts in Bangalore, Karnataka.'
            },
            {
              title: '10. Contact',
              content: 'For any questions regarding these terms, please contact us at hello@ecoleminds.com.'
            },
          ].map((section, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.05 }}
              className="mb-8"
            >
              <h2 className="text-xl font-bold text-slate-900 mb-3">{section.title}</h2>
              <p className="text-slate-600 leading-relaxed">{section.content}</p>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
}
